import { Children, isValidElement } from 'react';
import {
  Box,
  BoxProps,
  Flex,
  Icon,
  IconButton,
  IconName
} from '../../../../atoms';
import { OutletHeaderBackButton } from './outlet-back-button';
import { OutletHeaderExtra } from './outlet-header-extra';
import { OutletHeaderHeading } from './outlet-heading';

export function OutletHeader({
  children,
  onClose,
  ...rest
}: BoxProps & { onClose?: () => void }): JSX.Element {
  let heading: JSX.Element | null = null;
  let backButton: JSX.Element | null = null;
  let extra: JSX.Element | null = null;

  Children.forEach(children, (child) => {
    if (!isValidElement(child)) {
      return;
    }
    if (child.type === OutletHeaderHeading) {
      heading = child;
    }
    if (child.type === OutletHeaderBackButton) {
      backButton = child;
    }
    if (child.type === OutletHeaderExtra) {
      extra = child;
    }
  });
  return (
    <Flex flexDir="column" w="100%" p="space_unit.x2" {...rest}>
      {onClose && (
        <Flex justifyContent="flex-end">
          <IconButton
            variant="unstyled"
            border="none"
            onClick={onClose}
            _hover={{ cursor: 'pointer' }}
            aria-label="close-button"
            icon={<Icon w="20px" h="20px" name={IconName.Close} />}
          />
        </Flex>
      )}
      <Box>
        {backButton && backButton}
        {heading && heading}
        {extra && extra}
      </Box>
    </Flex>
  );
}
